import styled from 'styled-components';

// Utils
import { ButtonIconBackground } from '../../../inputs/buttons/ButtonIconBackground';
import { Row } from '../styles';

// Components

export const MainContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.m}rem;
  /* Bug #6: mapa y formulario al 50/50 en escritorio. Ambos hijos comparten
     el ancho disponible en lugar de pelearse con max-width fijos. */
  & > * {
    flex: 1 1 0;
    min-width: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column;
    & > * {
      flex: 0 1 auto;
    }
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  /* Cap suave en monitores 4K+ para que el mapa no se vuelva enorme */
  max-width: 100rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    height: 45rem;
    max-width: initial;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    height: 50rem;
  }
`;

export const RowStyled = styled(Row)`
  align-items: flex-start;
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
`;

export const RoadInputsGroup = styled.div`
  display: flex;
  gap: 1rem;
`;

export const GreenButton = styled(ButtonIconBackground)`
  align-self: center;
  background: ${({ theme }) => theme.colors.green};
`;

export const BlackButton = styled(ButtonIconBackground)`
  align-self: center;
  background: ${({ theme }) => theme.colors.black};
`;
